/* Siluetopía · acciones del carrito desplegable: agregar historia o regalo y aplicar el precio de paquete sin salir del carrito. */
(function () {
  function refrescar(state) {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function' && state && state.sections) {
      d.classList.remove('is-empty');
      d.renderContents(state);
      return;
    }
    window.location.reload();
  }
  function seccionesDe() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
  }
  function aplicarCodigo(codigo) {
    return codigo ? fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }) : Promise.resolve();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st-cx-add], [data-st-cx-codigo]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-st-cx]');
    var codigo = box ? box.dataset.codigo : '';
    var activo = box && box.dataset.activo === 'true';
    btn.disabled = true; btn.classList.add('is-cargando');
    var paso = (!activo && (btn.hasAttribute('data-con-codigo') || btn.hasAttribute('data-st-cx-codigo'))) ? aplicarCodigo(codigo) : Promise.resolve();
    paso.then(function () {
      if (btn.hasAttribute('data-st-cx-codigo')) {
        return fetch('/?sections=' + seccionesDe().join(',')).then(function (r) { return r.json(); }).then(function (secs) { refrescar({ sections: secs }); });
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-st-cx-add'), 10), quantity: 1 }], sections: seccionesDe().join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(refrescar);
    }).catch(function () { btn.disabled = false; btn.classList.remove('is-cargando'); });
  });
  // Pagar al recibir: despliega el formulario de Releasit dentro del carrito
  function abrirCOD() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    if (!d.querySelector('#rsi_form_wrapper')) {
      try { sessionStorage.setItem('st-abrir-cod', '1'); } catch (e) {}
      window.location.href = '/cart';
      return;
    }
    d.classList.add('st-cod-abierto');
    var w = d.querySelector('#rsi-form-top-anchor, #cart-wrapper');
    if (w) {
      if (!d.querySelector('.st-cx-cod-volver')) {
        var v = document.createElement('button'); v.type = 'button'; v.className = 'st-cx-cod-volver'; v.textContent = '← Volver al carrito';
        v.addEventListener('click', function () { d.classList.remove('st-cod-abierto'); });
        w.parentNode.insertBefore(v, w);
      }
      setTimeout(function () { w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
    }
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-st-cod-abrir]')) { e.preventDefault(); abrirCOD(); } });
  var pedirCOD = false;
  try { pedirCOD = sessionStorage.getItem('st-abrir-cod') === '1'; sessionStorage.removeItem('st-abrir-cod'); } catch (e) {}
  if (pedirCOD) {
    var t = 0, iv = setInterval(function () {
      var d = document.querySelector('cart-drawer');
      if ((d && d.querySelector('#rsi_form_wrapper')) || ++t > 40) {
        clearInterval(iv);
        if (d && typeof d.open === 'function') d.open();
        setTimeout(abrirCOD, 400);
      }
    }, 250);
  }
  // Vaciar carrito (pide confirmar con un segundo toque)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-st-vaciar]'); if (!b) return;
    e.preventDefault();
    if (!b.classList.contains('is-confirmar')) {
      b.classList.add('is-confirmar'); b.textContent = '¿Seguro? Toca de nuevo para vaciar';
      setTimeout(function () { if (b.isConnected) { b.classList.remove('is-confirmar'); b.textContent = 'Vaciar carrito'; } }, 4000);
      return;
    }
    b.disabled = true; b.textContent = 'Vaciando…';
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () { return fetch(window.location.pathname + '?sections=' + seccionesDe().join(',')); })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        var d = document.querySelector('cart-drawer');
        Object.keys(secs).forEach(function (id) {
          var html = new DOMParser().parseFromString(secs[id], 'text/html');
          var nuevo = html.querySelector('#CartDrawer');
          if (nuevo) {
            var viejo = document.querySelector('#CartDrawer');
            if (viejo) viejo.innerHTML = nuevo.innerHTML;
          } else {
            var el = document.getElementById(id), src = html.getElementById('shopify-section-' + id);
            if (el && src) el.innerHTML = src.innerHTML;
          }
        });
        if (d) d.classList.add('is-empty');
      })
      .catch(function () { window.location.reload(); });
  });
  // Rotación de reseñas en el carrito
  setInterval(function () {
    document.querySelectorAll('[data-st-citas]').forEach(function (c) {
      var ps = c.querySelectorAll('p'); if (ps.length < 2) return;
      var i = [].findIndex.call(ps, function (p) { return p.classList.contains('is-on'); });
      ps[i].classList.remove('is-on'); ps[(i + 1) % ps.length].classList.add('is-on');
    });
  }, 4000);
})();
